import { createAction } from 'redux-actions'
import Api from '../Api'

import { SAVE_RIDER } from './rider'

export const ADD_RIDER_STAGEPLAN_ITEM = createAction('ADD_RIDER_STAGEPLAN_ITEM')
export const REMOVE_RIDER_STAGEPLAN_ITEM = createAction('REMOVE_RIDER_STAGEPLAN_ITEM')
export const CREATE_RIDER_STAGEPLAN_ITEM = createAction('CREATE_RIDER_STAGEPLAN_ITEM')
export const EDIT_RIDER_STAGEPLAN_ITEM = createAction('EDIT_RIDER_STAGEPLAN_ITEM')
export const DELETE_RIDER_STAGEPLAN_ITEM = createAction('DELETE_RIDER_STAGEPLAN_ITEM')

export const addRiderStageplanItem = (item) => {
  return (dispatch) => dispatch(ADD_RIDER_STAGEPLAN_ITEM({item}))
}

export const removeRiderStageplanItem = (index) => {
  return (dispatch) => dispatch(REMOVE_RIDER_STAGEPLAN_ITEM({index}))
}

export const createRiderStageplanItem = (stageplanId, item) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(CREATE_RIDER_STAGEPLAN_ITEM(Api.createRiderStageplanItem(stageplanId, item)))
  }
}

export const editRiderStageplanItem = (item, index) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return Api.editRiderStageplanItem(item)
      .then(({data}) => dispatch(EDIT_RIDER_STAGEPLAN_ITEM({data, index})))
  }
}

export const deleteRiderStageplanItem = (item, index) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return Api.deleteRiderStageplanItem(item)
      .then(({data}) => dispatch(DELETE_RIDER_STAGEPLAN_ITEM({data, index})))
  }
}



// WEBPACK FOOTER //
// ./src/actions/rider-stageplan-item.js